import types from './actionTypes';

const initialAiState = {
  isOpen: false,
  loading: false,
  messages: [],
  error: null,
};

const initialState = {
  loading: false,
  demTemplates: [],
  selectedTemplate: null,
  error: '',
  ai: initialAiState,
};

const MAX_AI_MESSAGES = 12;

const capAiConversationMessages = (messages) => {
  if (messages.length <= MAX_AI_MESSAGES) return messages;
  const cappedMessages = messages.slice(-MAX_AI_MESSAGES);
  return cappedMessages[0]?.role === 'assistant'
    ? cappedMessages.slice(1)
    : cappedMessages;
};

const demTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_DEM_TEMPLATE_STATE:
      return { ...initialState, ai: initialAiState };

    case types.SYNC_DEM_TEMPLATES.REQUEST:
    case types.FETCH_DEM_TEMPLATE.REQUEST:
    case types.CREATE_DEM_TEMPLATE.REQUEST:
    case types.UPDATE_DEM_TEMPLATE.REQUEST:
    case types.DUPLICATE_DEM_TEMPLATE.REQUEST:
    case types.ARCHIVE_DEM_TEMPLATE.REQUEST:
      return { ...state, loading: true, error: '' };

    case types.SYNC_DEM_TEMPLATES.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        demTemplates: [...action.demTemplates],
      };

    case types.FETCH_DEM_TEMPLATE.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        selectedTemplate: action.template,
      };

    case types.CREATE_DEM_TEMPLATE.SUCCESS:
    case types.UPDATE_DEM_TEMPLATE.SUCCESS:
    case types.DUPLICATE_DEM_TEMPLATE.SUCCESS:
    case types.ARCHIVE_DEM_TEMPLATE.SUCCESS:
      return { ...state, loading: false, error: '' };

    case types.SYNC_DEM_TEMPLATES.FAILURE:
    case types.FETCH_DEM_TEMPLATE.FAILURE:
    case types.CREATE_DEM_TEMPLATE.FAILURE:
    case types.UPDATE_DEM_TEMPLATE.FAILURE:
    case types.DUPLICATE_DEM_TEMPLATE.FAILURE:
    case types.ARCHIVE_DEM_TEMPLATE.FAILURE:
      return { ...state, loading: false, error: action.error.message };

    case types.GENERATE_AI_DEM_TEMPLATE.REQUEST: {
      const userMessageId = Date.now().toString(36) + Math.random().toString(36).slice(2);
      return {
        ...state,
        ai: {
          ...state.ai,
          loading: true,
          error: null,
          messages: [
            ...state.ai.messages,
            { id: userMessageId, role: 'user', content: action.prompt },
          ],
        },
      };
    }

    case types.GENERATE_AI_DEM_TEMPLATE.SUCCESS: {
      const assistantMessageId = Date.now().toString(36) + Math.random().toString(36).slice(2);
      const nextMessages = capAiConversationMessages([
        ...state.ai.messages,
        {
          id: assistantMessageId,
          role: 'assistant',
          content: action.message,
          design: action.design,
          designSnapshotBefore: action.designSnapshotBefore,
        },
      ]);
      return {
        ...state,
        ai: {
          ...state.ai,
          loading: false,
          error: null,
          messages: nextMessages,
        },
      };
    }

    case types.GENERATE_AI_DEM_TEMPLATE.FAILURE:
      return {
        ...state,
        ai: {
          ...state.ai,
          loading: false,
          error: action.error,
          messages: state.ai.messages.slice(0, -1),
        },
      };

    case types.TOGGLE_AI_PANEL:
      return { ...state, ai: { ...state.ai, isOpen: !state.ai.isOpen } };

    case types.RESET_AI_CONVERSATION:
      return { ...state, ai: { ...state.ai, messages: [], error: null } };

    case types.UNDO_LAST_AI_DESIGN: {
      const idx = state.ai.messages.findIndex((m) => m.id === action.messageId);
      if (idx === -1) return state;
      const hasPromptBefore = idx > 0 && state.ai.messages[idx - 1]?.role === 'user';
      const nextLength = hasPromptBefore ? idx - 1 : idx;
      return {
        ...state,
        ai: { ...state.ai, messages: state.ai.messages.slice(0, nextLength) },
      };
    }

    default:
      return state;
  }
};

export default demTemplateReducer;
